export enum ContactDataType {
    Email,
    Sms,
}
